import React, { useEffect, useState } from "react";
import BasicModal from "../../../components/models/models";
import PlanUsageCard from "./components/plan-usage-card";
import PrintingUsageCard from "./components/printing-usage-card";
import FeedbackAndRequestServiceCards from "./components/feedback-and-request-service-cards";
import Header from "./components/header";
import PillCards from "./components/pill-cards";
import ServicesRequestAndFeedbackCards from "./components/services-request-and-feedback-cards";
import { useDispatch, useSelector } from "react-redux";
import {
  getUsageReportRequest,
  getPrintingUsageReport,
  selectPersonalDashboard,
} from "../../../redux/slices/personalDashboardSlice";
import { useParams } from "react-router-dom";
import { selectUser } from "../../../redux/slices/userSlice";

function UsageReportModule({ path, show, setShow }) {
  const [popup, setPopup] = useState(false);
  const [state, setState] = useState(0);
  const [userServiceId, setuserServiceId] = useState();
  const [reqId, setReqId] = useState();
  const [dashboard, setDashboard] = useState();
  const [feedbackID, setFeedbackID] = useState();
  const State = useSelector(selectPersonalDashboard);
  const { usageReportData, servicesData, printingUsageReportData } = State;
  const dataPlans = usageReportData.data_plans;
  const printingData = printingUsageReportData.printing_usages_data;
  const active_billing_month = printingUsageReportData.active_billing_month;
  const customBillingPeriodId = servicesData?.custom_billing_period?.id
  const dispatch = useDispatch();
  const { id } = useParams();
  const { userDetails } = useSelector(selectUser);

  useEffect(() => {
    dispatch(getUsageReportRequest(id, customBillingPeriodId));
  }, [id, popup, dispatch]);

  useEffect(() => {
    dispatch(getPrintingUsageReport(id, customBillingPeriodId));
  }, [id, popup, dispatch]);

  return (
    <div
      onClick={() => {
        setShow(true);
      }}
      className="right_panel h-[100vh] md:h-[auto] relative flex flex-col pt-[12px] w-[100%] xl:max-w-[1099px] 6xl:max-w-[80%] lg:pl-[24px] xl:pl-0 lg:pr-[24px]"
    >
      <Header
        path={path}
        data={usageReportData}
        setShow={setShow}
        show={show}
      />
      <div className="card-section px-3 md:px-0">
        <div className="cards_wrap flex flex-col gap-[12px] md:gap-[24px] lg:gap-[48px] pt-[12px] md:pt-[32px] pb-[20px] overflow-y-scroll scrollbar-hide h-[calc(100vh-113px)] md:h-[calc(100vh-180px)]">
          <PillCards
            data={usageReportData}
            servicesData={servicesData}
            setPopup={setPopup}
            modalId={id}
            setState={setState}
            userDetails={userDetails}
          />

          <FeedbackAndRequestServiceCards
            setId={setuserServiceId}
            data={usageReportData}
            setPopup={setPopup}
            setState={setState}
          />

          {usageReportData?.service?.category_name === "Mobile Phone" && (
            <PlanUsageCard dataPlans={dataPlans} />
          )}

          {usageReportData?.service?.category_name === "Printing" && (
            <PrintingUsageCard
              printingData={printingData}
              active_billing_month={active_billing_month}
            />
          )}

          <ServicesRequestAndFeedbackCards
            data={usageReportData}
            setFeedbackID={setFeedbackID}
            setPopup={setPopup}
            setState={setState}
            setReqId={setReqId}
            setDashboard={setDashboard}
          />
        </div>
      </div>

      {setPopup && (
        <BasicModal
          id={{
            serviceId: usageReportData?.service?.id,
            userId: usageReportData?.user?.id,
            feedbackId: feedbackID,
            id: usageReportData?.service?.id,
            reqid: reqId,
          }}
          feedid={{ id: usageReportData?.service?.id, feedbackId: feedbackID }}
          feedBackId={feedbackID}
          state={state}
          popup={popup}
          setPopup={setPopup}
          setState={setState}
          dashboard={dashboard}
        />
      )}
    </div>
  );
}

export default UsageReportModule;
